import { axiosPatch, axiosPost } from './axiosService';

const getOTPURI = `/otp`;
const updateMobileNumber = '/Users/me/PhoneNumber';

export class OtpService {
	verifyOTP(form) {
		return axiosPost(
			form,
			`${getOTPURI}/verify`,
			{
				hide_success_toaster: true,
			},
			'json'
		);
	}

	sendOTP(corrolationId, type, bypassDeviceTrust = false) {
		return axiosPost(
			{
				corrolationId: corrolationId,
				type: type,
				bypassDeviceTrust: bypassDeviceTrust,
			},
			`${getOTPURI}/send`
		);
	}

	skipDeviceTrust() {
		return axiosPost(null, `${getOTPURI}/SkipDeviceTrust`);
	}

	unAuthVerifyOTP(form) {
		return axiosPost(form, `${getOTPURI}/UnauthorizedVerify`, {}, 'json');
	}

	unAuthSendOTP(corrolationId, type, userEmail, bypassDeviceTrust = false) {
		return axiosPost(
			{
				corrolationId: corrolationId,
				type: type,
				userEmail: userEmail,
				bypassDeviceTrust: bypassDeviceTrust,
			},
			`${getOTPURI}/UnauthorizedSend`
		);
	}

	updateMobileNumber(phoneNumber) {
		return axiosPatch(updateMobileNumber, phoneNumber);
	}
}
